import React, { useEffect, useState } from "react";
import styles from "./WalletOverview.module.sass";
import Wallet from "../../components/Wallet";
import { useTranslation } from "react-i18next";
import { fetchWallets } from "store/actions";
import { useDispatch } from "react-redux";
import AssetBalances from "./AssetBalances";
import {fetchAvailableAssets,  } from 'store/general/assets/actions'


const WalletOverview = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();


  const loadWallets = () => {
    dispatch(fetchWallets());
  };
  useEffect(() => {
    loadWallets({});
    dispatch(fetchAvailableAssets())
  }, []);

  return (
    <Wallet>
      <div className={styles.list}>
        <div className={styles.item}>
          <div className={styles.head}>{t("Account Balances")}</div>
          <div className={styles.body}>
            <AssetBalances
            />
          </div>
        </div>
      </div>
    </Wallet>
  );
};

export default WalletOverview;
